module.exports = __webpack_public_path__ + "static/media/stefano100.227c1b8c.jpg";